/**
 * The call engine, loaded from the calls service at runtime.
 *
 * It is deliberately NOT bundled here. One build of the engine is served by the
 * calls service and used by every app that calls through it, so a fix there
 * reaches us on the next reload instead of waiting for someone to copy the
 * files across again — which is exactly how the copies drifted before.
 *
 * Its types are committed in `src/types/calls-sdk.d.ts`, refreshed with
 * `node scripts/fetch-calls-sdk-types.js`.
 */
import type * as CallsSdk from "calls-sdk";

export type CallsSdkModule = typeof CallsSdk;

let pending: Promise<CallsSdkModule> | null = null;
let loadedFrom: string | null = null;

export function loadCallsSdk(url: string): Promise<CallsSdkModule> {
  if (pending && loadedFrom === url) return pending;
  loadedFrom = url;
  pending = import(/* webpackIgnore: true */ url)
    .then((mod) => mod as CallsSdkModule)
    .catch((e) => {
      // a failed load must not poison every later attempt — the service may
      // simply have been restarting
      pending = null;
      loadedFrom = null;
      throw e;
    });
  return pending;
}
